import { FC } from 'react';
import GroupScheduleShell from '../group-schedule/group-schedule-shell';

const GroupSchedulePage: FC = () => <GroupScheduleShell />;

export default GroupSchedulePage;
